module.exports = __webpack_public_path__ + "static/media/S (9).dc316fe1.jpg";